
let carouselManager = {
    index : 1,
    changeSlide: function() {
        Array.prototype.forEach.call(carouselManager.domElements.carouselSlideButtonList, (item) => {
            item.classList.remove('active');
        });
        document.querySelector('#carousel-slide-' + (carouselManager.index - 1)).classList.add('active');

        Array.prototype.forEach.call(carouselManager.domElements.carouselSlideList, (slide) => {
            slide.style.display = 'none';
        });

        document.querySelector('#mcl-couse-hero-' + carouselManager.index).style.display = 'block';
    },

    domElements: {
        carouselSlideButtonList : document.querySelectorAll('.mcl-hero-carousel-navigator-wrapper > .mcl-hero-carousel-course-container'),
        carouselSlideList : document.querySelectorAll('.mcl-home-course'),
        arrowLeft : document.querySelector('#mcl-carousel-arrow-left'),
        arrowRight : document.querySelector('#mcl-carousel-arrow-right')
    }
};

(function() {
    var buttons = carouselManager.domElements.carouselSlideButtonList;
    if(buttons.length) {
        buttons[carouselManager.index - 1].classList.add('active');
        Array.prototype.forEach.call(buttons,((element, index) => {
            element.id = 'carousel-slide-' + index;
            element.addEventListener('click', () => {
                carouselManager.index = index + 1;
                carouselManager.changeSlide();
            });
        }));
    }

    if(carouselManager.domElements.arrowLeft) {
        carouselManager.domElements.arrowLeft.addEventListener('click', () => {
            carouselManager.index > 1 ? carouselManager.index-- : carouselManager.index = carouselManager.domElements.carouselSlideButtonList.length;
            carouselManager.changeSlide();
        });
    }

    if(carouselManager.domElements.arrowRight) {
        carouselManager.domElements.arrowRight.addEventListener('click', () => {
            carouselManager.index < carouselManager.domElements.carouselSlideButtonList.length ? carouselManager.index++ : carouselManager.index = 1;
            carouselManager.changeSlide();
        });
    }

})();



// WEBPACK FOOTER //
// ./src/components/templates/hero-carousel/hero-carousel.js